import api from "./api";

export async function fetchAttemptedGamificationList(params = {}) {
  const response = await api.get("/gamification/attempted-gamification-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchGamificationBattle() {
  const response = await api.get("/gamification/battle");

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchGamificationCoinStore() {
  const response = await api.get("/gamification/coin-store");

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchUserCoinsHistory(params = {}) {
  const response = await api.get("/gamification/user-coins-history", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchGamificationFilterList() {
  const response = await api.get("/gamification/filter-list");

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchGamificationLeaderboard(params = {}) {
  const response = await api.get("/gamification/get-battle-leaderboard-data", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchGamificationUserRankList(params = {}) {
  const { type = "all", ...requestParams } = params;
  const response = await api.get("/gamification/user-rank-list", {
    params: {
      type,
      ...requestParams,
    },
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchGamificationAnswerSheet(params = {}) {
  const response = await api.get("/gamification/answer-sheet", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
